import { render, staticRenderFns } from "./NavigationLogo.vue?vue&type=template&id=71ff55d9&"
var script = {}
import style0 from "./NavigationLogo.vue?vue&type=style&index=0&id=71ff55d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports